"use strict";
(function footerPlugin(global) {

  /**
  * Плагин для области навигации между страницами таблицы.
  *
  * @property {string} name Имя плагина.
  * @property {integer} pageIndex Текущая страница
  * @property {integer} pageSize Количество строк таблицы на странице
  * @since 5.2.0.1100
  * @class WebAccess.components.dataViews.gridPlugins.FooterPlugin
  * @extends WebAccess.Plugin
  */
  global.FooterPlugin = WA.Plugin.extend({
    name: 'FooterPlugin',

    pageIndex: 0,
    pageSize: 100, // Для реального количества записей на странице используется значение из константы REFERENCE_RECORDS_PAGE_SIZE в бекэнде.

    _grid: null,
    _jPager: null,
    _jPagerControls: null,
    _selectExpression: null,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function () {
      this._super();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Регистрирует плагин.
    *
    * @method WebAccess.components.dataViews.gridPlugins.FooterPlugin#register
    * @param {WebAccess.components.dataViews.Grid} grid Таблица.
    * @since 5.2.0.1100
    * @return {object} Ассоциативный массив, содержащий публичные методы.
    */
    register: function (grid) {
      var me = this;
      me._super();

      me._grid = grid;

      grid.bind(WA.CMP.DV.Grid.EVENT.STATE_LOADED, $.proxy(me._afterGridStateLoaded, me));
      grid.bind(WA.CMP.DV.Grid.EVENT.AFTER_DATA_LOADED, $.proxy(me._afterGridDataLoaded, me));
      grid.bind(WA.CMP.DV.Grid.EVENT.GRID_INIT, $.proxy(me._onGridInit, me));

      return {
        'updateFooter': $.proxy(me._updateFooter_exported, me)
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обрабатывает события до инициализации таблицы.
    *
    * @param {object} slickGrid Таблица
    * @since 5.2.0.1100
    * @method WebAccess.components.dataViews.gridPlugins.FooterPlugin#_onGridInit
    */
    _onGridInit: function (slickGrid) {
      var me = this;

      me.initPager().done(function () {

        // Обновление состояния кнопок, в зависимости от количества оставшихся записей.
        me._grid.bind(WA.CMP.DV.Grid.EVENT.DATA_LOADED, function (index, recordsCount, records) {

          me.renderTemplates().done(function () {

            index = index || "0"
            index = +index;

            recordsCount = +recordsCount;

            if (recordsCount < me.pageSize && !me._grid.state.GroupColumns.length && index === 0) {
              me._setCountLabel(recordsCount);
            }

            me.pageIndex = index;

            if (index === 0 && recordsCount <= me.pageSize) {
              me._jPagerControls.navPanel.hide();
            } else {
              me._jPagerControls.navPanel.show();
            }

            if (index > 0) {
              // используемая версия jQuery не умеет работать с css-классами элементов svg. Приходится использовать data-атрибуты.
              me._jPagerControls.prev.add(me._jPagerControls.first).attr('data-disabled', 'false');
            } else {
              me._jPagerControls.prev.add(me._jPagerControls.first).attr('data-disabled', 'true');
            }

            var recordsFrom = (index * me.pageSize) + 1;
            var recordsTo = (index + 1) * me.pageSize;

            if (!isNaN(recordsCount)) {
              // Если реально вернулось больше чем нужно, то значит у нас есть следующая страница.
              if (recordsCount <= me.pageSize) {
                recordsTo = recordsFrom + recordsCount - 1;
                me._jPagerControls.next.add(me._jPagerControls.last).attr('data-disabled', 'true');
              } else {
                me._jPagerControls.next.add(me._jPagerControls.last).attr('data-disabled', 'false');
              }
            }

            var currentPageText = (recordsCount > 1) ? (recordsFrom + ' - ' + recordsTo) : (index + recordsCount);
            me._jPagerControls.currentPage.text(currentPageText);

            // Если реально вернулось больше чем нужно, то значит у нас есть следующая страница, а эту лишную запись удалим, т.к. она загрузится на след. странице.
            if (recordsCount > me.pageSize) {
              // Удаляем лишнюю строку.
              records.pop();
            }
          });
        });

        // Перемотка кверху при переключении страницы.
        me._grid.bind(WA.CMP.DV.Grid.EVENT.PAGE_CHANGE, function () {
          me._grid.grid.scrollRowToTop(0);
        });

      });

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обрабатывает события завершения загрузки состояния таблицы.
    *
    * @param {object} slickGrid Таблица.
    * @since 5.2.0.1100
    * @method WebAccess.components.dataViews.gridPlugins.FooterPlugin#_onGridInit
    */
    _afterGridStateLoaded: function () {
      var me = this;

      // Проверяем надо ли восстанавливать номер страницы.
      var gridId = me._grid.containerSelector; //другого ИД у нас тут еще нет.
      var url = new WA.URL();
      var pageIndexSaved = $.parseJSON(decodeURIComponent(url.getParamInHash('pageIndexSaved')) || '[]');
      if (pageIndexSaved.indexOf(gridId) === -1) {
        // Сбрасываем состояние страницы.
        WA.cache.setItem('grid.pageIndex.' + gridId, 0);
        // Добавляем текущий грид в состояние сохранения номера страницы грида.
        pageIndexSaved.push(gridId);
        url.setParamInHash('pageIndexSaved', encodeURIComponent($.toJSON(pageIndexSaved)));
        window.location.href = url.asString();
      }

      // Восстанавливаем номер страницы.
      me._grid.updateState({
        PageIndex: +WA.cache.getItem('grid.pageIndex.' + gridId) || 0
      });

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обрабатывает события до завершения загрузки данных.
    *
    * @param {object} slickGrid Таблица.
    * @since 5.2.0.1100
    * @method WebAccess.components.dataViews.gridPlugins.FooterPlugin#_onGridInit
    */
    _afterGridDataLoaded: function () {
      var me = this;

      // Сохраняем номер страницы для последующего восставновления при перезагрузке страницы браузера.
      var gridId = me._grid.containerSelector;
      WA.cache.setItem('grid.pageIndex.' + gridId, me._grid.state.PageIndex);

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
   * Публичная функция для обновления пагинатора.
   * @param {object} slickGrid грид
   * @since 5.2.0.1100
   * @method WebAccess.components.dataViews.gridPlugins.FooterPlugin#_updateFooter_exported
   */
    _updateFooter_exported: function () {
      this.renderTemplates();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Включает область навигации.
    *
    * @since 5.2.0.1100
    * @param {String} containerSelector Блок, содержащий таблицу.
    * @method WebAccess.components.dataViews.gridPlugins.FooterPlugin#initPager
    * @return {WebAccess.components.dataViews.gridPlugins.FooterPlugin} FooterPlugin Навигация между страницами таблицы.
    */
    initPager: function () {
      var me = this;
      var jGridContainer = $(me._grid.containerSelector);

      if (me._grid.state.PageIndex) me.pageIndex = +me._grid.state.PageIndex;
      if (me._grid.state.Take) me.pageSize = +me._grid.state.Take;
      me._jPager = $('<div class="slick-enhancement-pager w100">');
      jGridContainer.append(me._jPager);

      return me.renderTemplates();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Генерирует область навигации из шаблона.
    *
    * @since 5.2.0.1100
    * @method WebAccess.components.dataViews.gridPlugins.FooterPlugin#renderTemplates
    * @return {WebAccess.components.dataViews.gridPlugins.FooterPlugin} FooterPlugin Навигация между страницами таблицы.
    */
    renderTemplates: function () {
      var me = this;
      var state = me._grid.state;

      var selectOn = function (limit) {
        if (limit == me.pageSize) return 'selected="selected"';
      };

      var partials = {
        left: "referenceRecords/status.html",
        center: "referenceRecords/filters.html",
        right: "referenceRecords/paginator.html"
      }

      var currentFilter = state.CurrentFilter || { 'Name': '', 'DisplayValue': '', 'DisplayHint': '', 'isEnabled': false }
      var currentRecordsRange = (me.pageIndex * me.pageSize) > 0 ? ((me.pageIndex * me.pageSize) + 1) + ' - ' + ((me.pageIndex + 1) * me.pageSize) : '1 - ' + me.pageSize;
      var filterName = $.trim(currentFilter.Name);

      var data = WA.TMPL.prepare({
        ID: 'reference_footer',
        'class': 'dxgvPagerBottomPanel',
        HasFilterExpression: (currentFilter.DisplayValue !== ''),
        CurrentFilterName: filterName.trunc(50),
        CurrentFilterNameHint: filterName,
        FilterExpression: currentFilter.DisplayValue,
        FilterHint: currentFilter.DisplayHint,
        IsFilterEnabled: currentFilter.IsEnabled,
        CurrentRecordsRange: currentRecordsRange,
        CurrentPage: me.pageIndex + 1,
        PageIndex: me.pageIndex,
        Options: [
          { Name: 15, Selected: selectOn(15) },
          { Name: 25, Selected: selectOn(25) },
          { Name: 50, Selected: selectOn(50) },
          { Name: 100, Selected: selectOn(100) }
        ],
        FirstDisabled: false,
        PrevDisabled: false,
        NextDisabled: false,
        LastDisabled: false
      });


      return WA.TMPL.render('layouts/3Columns.html', data, false, false, partials).done(function (pager) {

        me._jPager.html(pager);

        me._grid.grid.setOptions({
          showPagerRow: true,
          pagerRowHeight: me._jPager.outerHeight()
        });

        me._grid.grid.resizeViewport();

        me._bindEvents();
        me._initCounter();
      });

    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обработчики событий
    * @since 5.2.0.1100
    * @private
    * @method WebAccess.components.dataViews.gridPlugins.FooterPlugin#_bindEvents
    * @return {WebAccess.components.dataViews.gridPlugins.FooterPlugin} FooterPlugin
    */
    _bindEvents: function () {
      var me = this;
      me._jPagerControls = {
        resetFilterState: $('.resetFilterState', me._jPager),
        changeFilterState: $('.changeFilterState', me._jPager),
        navPanel: $('.grid-paginator', me._jPager),
        next: $('#gridNextPage', me._jPager),
        prev: $('#gridPrevPage', me._jPager),
        first: $('#gridFirstPage', me._jPager),
        last: $('#gridLastPage', me._jPager),
        pageSize: $('.gridChangePageSize', me._jPager),
        currentPage: $('.gridCurrentPage', me._jPager)
      };

      me._bindFilterEvents();
      me._bindPagerEvents();

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    // Навешивает элементы управления фильтром.
    _bindFilterEvents: function () {
      var me = this;

      // Очистить фильтр.
      me._jPagerControls.resetFilterState.click(function () {
        window.Filters.resetFilter();
      });

      // Вкл/Выкл фильтра
      me._jPagerControls.changeFilterState.click(function () {
        window.Filters.changeFilterState($(this).is(':checked'));
      });

      return me;
    },

    // Навешивает события на пагинатор.
    _bindPagerEvents: function () {
      var me = this;

      var isDisabled = function (el) {
        el = $(el);
        // используемая версия jQuery не умеет работать с css-классами элементов svg. Приходится использовать data-атрибуты.
        if (el.attr('data-disabled') === 'true') return true;
        return false;
      };

      var afterClick = function (el) {
        el = $(el);
        el.attr('data-disabled', 'true');

        me._getData().done(function () {
          me._grid.fire(WA.CMP.DV.Grid.EVENT.PAGE_CHANGE, me.pageIndex);
          el.attr('data-disabled', 'false');
        });
      };

      me._jPagerControls.next.click(function () {
        if (isDisabled(this)) return;
        me.pageIndex += 1;
        afterClick(this);
      });

      me._jPagerControls.prev.click(function () {
        if (isDisabled(this)) return;
        me.pageIndex -= 1;
        if (me.pageIndex < 0) me.index = 0;
        afterClick(this);
      });

      me._jPagerControls.first.click(function () {
        if (isDisabled(this)) return;
        me.pageIndex = 0;
        afterClick(this);
      });

      me._jPagerControls.last.click(function () {
        if (isDisabled(this)) return;
        me.pageIndex = -1;
        afterClick(this);
      });

      me._jPagerControls.pageSize.change(function () {
        var prevPageLimit = me.pageSize;
        var prevPageIndex = me.pageIndex;

        me.pageSize = $(this).val();
        me.pageIndex = 0;
        afterClick(this);
        me._grid.fire(WA.CMP.DV.Grid.EVENT.PAGE_LIMIT_CHANGE, me.pageSize);
      });

      return me;
    },

    /**
    * Обработчик события нажатия на кол-во записей
    * @since 5.2.0.1100
    * @private
    * @method WebAccess.components.dataViews.gridPlugins.FooterPlugin#_initCounter
    * @return {WebAccess.components.dataViews.gridPlugins.FooterPlugin} FooterPlugin
    */
    _initCounter: function () {
      var me = this;
      $('.RowCount', me.jPager)
        .html(L("RECORDS_TOTAL_LINK"))
        .addClass('dashed')
        .attr("title", L("SHOW_EXACT_RECORDS_COUNT"))
        .one('click', $.proxy(me._toggleRecordCountDisplayMode, me)); //добавляем возможность получения точного количества записей
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Изменяет "Всего записей" на реальное количество.
    * @since 5.2.0.1100
    * @private
    * @method WebAccess.components.dataViews.gridPlugins.FooterPlugin#_initCounter
    * @return {WebAccess.components.dataViews.gridPlugins.FooterPlugin} FooterPlugin
    */
    _toggleRecordCountDisplayMode: function () {
      var me = this;
      var jRowCount = $('.RowCount', me.jPager).removeClass('dashed');

      var spinner = $('.counterSpinner', me.jPager);
      var spinnerShowDelay = setTimeout(function () {
        jRowCount.hide();
        spinner.show();
      }, 300);

      var filter = me._grid.state.GlobalPageFilter || '';
      var currentFilter = me._grid.state.CurrentFilter;
      if (currentFilter) {
        if (currentFilter.IsEnabled) {
          if (!filter) {
            filter = currentFilter.Expression;
          } else {
            if (currentFilter.Expression !== '') {
              filter = '(' + filter + ') & (' + currentFilter.Expression + ')';
            }
          }
        }
      }

      me._grid._dataSource.totalCount(filter, me._grid.state.GlobalPageFilterLikeQuery).done(function (res) {
        clearTimeout(spinnerShowDelay);
        spinner.hide();
        // Меняем на точное
        me._setCountLabel(res);
      });
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _setCountLabel: function (total) {
      var me = this;
      var jRowCount = $('.RowCount', me.jPager).removeClass('dashed');

      jRowCount
        .html(L("RECORDS_TOTAL", total))
        .attr("title", L("EXACT_RECORDS_COUNT"))
        .show();
    },

    /**
    * Отправка запроса на получение данных с учетом страницы и кол-ва записей
    * @private
    * @method getData
    */
    _getData: function () {
      var me = this;
      var loadOptions = {
        PageIndex: me.pageIndex,
        Take: me.pageSize
      };
      return me._grid.reloadData(loadOptions);
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

})(WA.components.dataViews.gridPlugins);
